import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ShieldCheck } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useAdminAuth } from "@/context/AdminAuthContext";
import { ADMIN } from "@/constants/testIds";
import { formatApiErrorDetail } from "@/lib/api";

const BG_IMAGE_URL = "https://images.unsplash.com/photo-1572282431238-bd1d44df8550";

export default function AdminLogin() {
  const { login } = useAdminAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSubmitting(true);
    try {
      await login(email, password);
      navigate("/admin/dashboard");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div
      className="min-h-screen relative flex items-center justify-center p-4"
      style={{ backgroundImage: `url(${BG_IMAGE_URL})`, backgroundSize: "cover", backgroundPosition: "center" }}
    >
      <div className="absolute inset-0 bg-slate-950/80" />
      <div className="relative z-10 w-full max-w-sm bg-white rounded-xl shadow-2xl overflow-hidden">
        <div className="bg-denso-red px-6 py-6 text-center">
          <ShieldCheck className="h-8 w-8 text-white mx-auto mb-2" />
          <h1 className="text-white font-heading font-bold text-lg">Admin Login</h1>
          <p className="text-white/80 text-xs mt-1">DENSO Training Manager Dashboard</p>
        </div>
        <form onSubmit={handleSubmit} className="p-6 space-y-4">
          <div className="space-y-1.5">
            <Label className="text-xs uppercase tracking-wide text-slate-500">Email</Label>
            <Input data-testid={ADMIN.emailInput} type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="admin@densotraining.co.za" />
          </div>
          <div className="space-y-1.5">
            <Label className="text-xs uppercase tracking-wide text-slate-500">Password</Label>
            <Input data-testid={ADMIN.passwordInput} type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="••••••••" />
          </div>
          {error && (
            <p data-testid={ADMIN.errorMessage} className="text-sm text-red-600 bg-red-50 rounded-md px-3 py-2">
              {error}
            </p>
          )}
          <Button type="submit" data-testid={ADMIN.loginButton} disabled={submitting} className="w-full bg-denso-red hover:bg-denso-lightred text-white h-11">
            {submitting ? "Signing in..." : "Sign In"}
          </Button>
        </form>
      </div>
    </div>
  );
}
